import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoHtmlTextEditor,
    RaikoSectionContainer, showErrorMessage, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {GameStageService} from "../../../serverService/gameService/GameStageService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import RaikoCustomEditor2 from "../../../raikoComponents/raikoEditor/RaikoCustomEditor2";

export default function GameStageDescription({gameStageId}) {

    const [actionButtonLoading, setActionButtonLoading] = useState(false);
    const [stageDescription, setStageDescription] = useState([])

    const service = new GameStageService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameStageDescriptionFromServer()
        }
    }, [gameStageId]);

    function getGameStageDescriptionFromServer() {
        loading.show()
        service.getGameStageDescription(gameStageId)
            .then((
                {
                    gameStageContent
                }) => {
                setStageDescription(gameStageContent)
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت توضیحات بازی"))
        }).finally(_ => {
            loading.hide()
        })

    }

    function handleUpdateGameStageDescription() {
        if (stageDescription.length > 0) {
            setActionButtonLoading(true)
            service.updateGameStageDescription(gameStageId,stageDescription)
                .then(response=>{
                    showSuccessMessage("توضیحات مرحله با موفقیت بروزرسانی شد.")
                }).catch(reason => {
                    showServerErrorMessage(reason)
            }).finally(_=>{
                setActionButtonLoading(false)
            })
        } else {
            showWarningMessage("لطفا ابتدا توضیحات مرحله را وارد نمایید.")
        }

    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"توضیحات مرحله"}
                    hasActionButton
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclick={handleUpdateGameStageDescription}
                >
                    <RaikoCustomEditor2
                        value={stageDescription}
                        setValue={setStageDescription}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}